import React from 'react';
export function Marquee() {
  const items = ['Facebook Ads', 'Instagram Ads', 'Captación de Leads', 'Escalado de Ventas', 'Embudos de Conversión', 'Creatividades que venden'];
  return <div className="py-[34px] border-b border-line overflow-hidden whitespace-nowrap group" data-id="element-111">
      <div className="inline-flex gap-[54px] animate-scroll will-change-transform group-hover:[animation-play-state:paused]" data-id="element-112">
        {[...items, ...items].map((item, i) => <span key={i} className="font-serif italic text-[1.7rem] text-ink-faint inline-flex items-center gap-[54px]" data-id="element-113">
            {item}
            <span className="not-italic text-acid text-[1rem]" data-id="element-114">✳</span>
          </span>)}
      </div>
    </div>;
}